module.exports = __webpack_public_path__ + "img/bn_n.8ce7df06.png";